import { useQuery } from "@tanstack/react-query";
import { getUserConfigRequest } from "../requests/user/config";
import { useAuth } from "../../contexts/auth/Context";
import { USER_CONFIG_QUERY_KEY } from "../../query/keys";

const DEFAULT_ERROR = "Error al obtener la configuración";

export const useUserConfig = () => {
  const { token, mustChangePassword, mustAcceptTerms } = useAuth();

  const {
    data: userConfig = null,
    isLoading,
    error: queryError,
    refetch: refreshUserConfig,
  } = useQuery({
    queryKey: USER_CONFIG_QUERY_KEY,
    queryFn: () => getUserConfigRequest(token!),
    enabled: !!token && !mustChangePassword && !mustAcceptTerms,
  });

  const error = queryError
    ? queryError instanceof Error
      ? queryError.message
      : DEFAULT_ERROR
    : null;

  return {
    userConfig,
    isLoading,
    error,
    refreshUserConfig,
  };
};
